<div class="{{isMobileMenu ? '' : 'sidemenu'}}" *ngIf="checkUserLogin();">
    <div class="sidemenu-head">
        <div class="usertitle">Hi, {{getUserName()}}</div>
        <!-- <div class="def">Thanks for being a her.store customer</div> -->
    </div>
    <ul class="side-nav-wrap">
        <ng-container *ngFor="let item of menuList">
            <li class="itemGroup">
                <ng-container *ngIf="item.menuItems">
                    <div class="sidelink"><a class="auto"><img [src]="item.icon"> {{item.title}}</a></div>
                    <ul class="submenu" >
                        <ng-container *ngFor="let menuItem of item.menuItems" >
                            <li class="sublinks" routerLinkActive="active"
                            [routerLink]="menuItem.url"
                            routerLinkActive="active">
                              <!-- <a [routerLink]="menuItem.url">{{menuItem.label}}</a> -->
                              <a (click)="navigateTo(menuItem.url)">{{menuItem.label}}</a>
                            </li>
                        </ng-container>
                    </ul>
                </ng-container>
                <ng-container *ngIf="!item.menuItems">
                    <div class="sidelink"
                    [class.active]="isActive(item.url)"
                    style="cursor: pointer;">
                      <!-- <a class="sublinks" [routerLink]="item.url"> -->
                      <a class="sublinks" (click)="navigateTo(item.url)">
                        <img [src]="item.icon"> {{item.label}}
                      </a>
                    </div>
                </ng-container>
            </li>
            <!-- <li class="side-item" *ngIf="!item.menuItems">
                <a class="route-link" [routerLink]="item.url"><img src="./assets/images/window.svg" class="side-icon" alt="window"/> {{item.label}}</a>
            </li> -->
        </ng-container>
        <li class="side-item">
            <a class="route-link" (click)="logoutUser()"><img src="./assets/images/logout-o.svg" class="side-icon" alt="window"/> Log Out</a>
        </li>
    </ul>
    <ul class="side-nav-wrap" *ngIf="0">
        <ng-container *ngFor="let item of menuList">
            <li class="side-item">
                <a class="route-link" [routerLink]="item.url"><img src="./assets/images/window.svg" class="side-icon" alt="window"/> {{item.label}}</a>
            </li>
        </ng-container>
        <li class="side-item">
            <a class="route-link" (click)="logoutUser()"><img src="./assets/images/logout-o.svg" class="side-icon" alt="window"/> Log Out</a>
        </li>
    </ul>
    <ul class="llgui" *ngIf="0">

        <!-- <li class="itemGroup">
            <div class="sidelink"><a>Your profile</a></div>
            <ul class="submenu">
                <li class="sublinks"><a routerLink="/personal-info">Personal Info</a></li>
                <li class="sublinks"><a routerLink="/address-book">Address book</a></li>
            </ul>
        </li> -->
        <!-- <li class="itemGroup">
            <div class="sidelink"><a>Her Store Manager</a></div>
            <ul class="submenu"> -->
                <ng-container *ngFor="let item of menuList">
                    <li class="itemGroup">
                        <div class="sidelink"><a><img [src]="item.icon"> {{item.title}}</a></div>
                        <ul class="submenu">
                            <ng-container *ngFor="let menuItem of item.menuItems">
                                <li class="sublinks"><a [routerLink]="menuItem.url">{{menuItem.label}}</a></li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>

            <!-- </ul>

        </li> -->
        <!-- <li class="itemGroup">
            <div class="sidelink"><a href="#">Your Customer</a></div>
            <ul class="submenu">
                <li class="sublinks"><a href="#">Ask Me Now </a></li>
                <li class="sublinks"><a href="#">Product reviews</a></li>
                <li class="sublinks"><a href="#">Seller Reviews </a></li>
                <li class="sublinks"><a href="#">Customer Logs</a></li>
            </ul>
        </li> -->

        <!-- <li class="itemGroup">
            <div class="sidelink"><a href="#">Community</a></div>
            <ul class="submenu">
                <li class="sublinks"><a href="#">Forum</a></li>
                <li class="sublinks"><a href="#">Academy</a></li>
                <li class="sublinks"><a href="#">Articles</a></li>
            </ul>
        </li> -->
        <!-- <li class="itemGroup">
            <div class="sidelink"><a href="#"></a></div>
            <ul class="submenu">
                <li class="sublinks"><a routerLink="/en/about">About</a></li>
                <li class="sublinks"><a routerLink="/en/terms-conditions">Terms & Condition</a></li>
                <li class="sublinks"><a routerLink="/en/disclaimers">Disclaimers</a></li>
                <li class="sublinks"><a routerLink="/en/policy">Policy</a></li>
                <li class="sublinks"><a routerLink="/en/sitemap">Sitemap</a></li>
                <li class="sublinks"><a href="#">Give Feedback</a></li>
            </ul>
        </li> -->
        <li class="itemGroup">
            <div class="sidelink">
                <!-- <button class="logbtn" (click)="logoutUser()">Log out</button> -->
                <a class="logbtn pointer" (click)="logoutUser()"><img src="./assets/images/logout-o.svg">Log Out</a>
            </div>
        </li>

        <li>
            <div class="sectionDivider"></div>
          </li>
    </ul>

    <c-modal id="delladdress" [visible]="showSuccessModal" backdrop="static" class="appModel" alignment="center">
        <div class="modelContentBox py-3 px-4" *ngIf="showSuccessModal">
            <div class="modelheader mb-3">

                <button (click)="handleSuccessModal()" cButtonClose class="modelClose"></button>
            </div>
            <div class="modelBOdy">
                <div class="msgCont">
                    <img src="./assets/images/checkmark.svg" alt="">
                    <p class="delmsg">The details has been updated Successfully.</p>

                </div>
            </div>
        </div>
    </c-modal>
</div>

<!-- <ng-template #nonLoginUserSideMenu>
    <div class="{{isMobileMenu ? '' : 'sidemenu'}}">
        <ul>
            <li class="itemGroup">
                <div class="sidelink"><a>Links</a></div>
                <ul class="submenu">
                    <li class="sublinks" *ngFor="let link of footerPageData.Links">
                        <a *ngIf="(link.link != '/')" routerLink="/{{link.link}}">{{link.label}}</a>
                    </li>
                </ul>
            </li>
            <li class="itemGroup">
                <div class="sidelink"><a>Support</a></div>
                <ul class="submenu">
                    <li class="sublinks" *ngFor="let support of footerPageData.support">
                        <a *ngIf="support.link != 'info@her.store' && support.link != '+91 9088609886'"
                            routerLink="/{{support.link}}">{{support.label}}</a>
                    </li>
                </ul>
            </li>
            <li class="itemGroup">
                <div class="sidelink"><a>Policies</a></div>
                <ul class="submenu">
                    <li class="sublinks" *ngFor="let meetus of footerPageData.Policies">
                        <a routerLink="/{{meetus.link}}">{{meetus.label}}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</ng-template> -->
